import { ref as s, onMounted as a, openBlock as o, createElementBlock as d, normalizeStyle as u } from "vue";
class h {
  constructor(e, t = {}) {
    this.el = e, this.embedType = "Inline", this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), this.onIframeLoaded = t.onLoad || (() => {
    });
  }
  build() {
    return this.node = document.createElement("iframe"), this.node.src = this.getSource(), this.node.width = "100%", this.node.height = "100%", this.node.frameBorder = "0", this.node.onload = (e) => {
      this.onIframeLoaded(e);
    }, this.node;
  }
  inject() {
    return this.el.appendChild(this.buildSpinner()), this.el.appendChild(this.node), this.format();
  }
  getSource() {
    let e = this.getParams(), t = "" + this.getUrl() + this.getDivider() + e;
    return this.filterConsentParam(t);
  }
  getUrl() {
    return this.url != null ? this.url : this.url = this.el.getAttribute("data-url").split("#")[0];
  }
  getDivider() {
    return this.getUrl().indexOf("?") === -1 ? "?" : "&";
  }
  getParams() {
    var e, t, i, n;
    t = "embed_domain=" + this.getDomain() + "&embed_type=" + this.embedType, i = this.getHostUtmParams();
    for (e in i)
      n = i[e], e in this.getBookingUtmParams() || (t += "&" + e + "=" + n);
    return t;
  }
  getUrlParams(e = "") {
    return e = e.split("?")[1], e ? JSON.parse('{"' + decodeURI(e).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}') : {};
  }
  getUtmUrlParams(e) {
    return this.getUrlParams(e);
  }
  getHostUtmParams() {
    return this.getUtmUrlParams(window.location.href);
  }
  getBookingUtmParams() {
    let e = this.getUrl();
    return this.getUtmUrlParams(e);
  }
  getDomain() {
    return encodeURIComponent(document.location.host);
  }
  filterConsentParam(e) {
    return e.replace(/consent_accept=1&?/g, "");
  }
  format() {
    return this.isMobile ? this.formatMobile() : this.formatDesktop();
  }
  formatDesktop() {
    return this.inlineStyles ? this.el.setAttribute("style", "position: relative;" + this.el.getAttribute("style")) : void 0;
  }
  formatMobile() {
    return this.inlineStyles ? this.el.setAttribute("style", "position: relative;overflow-y:auto;-webkit-overflow-scrolling:touch;" + this.el.getAttribute("style")) : this.el.className += " mobile";
  }
  buildSpinner() {
    var e;
    return e = document.createElement("div"), e.className = "spinner", e.appendChild(this.buildBounce(1)), e.appendChild(this.buildBounce(2)), e.appendChild(this.buildBounce(3)), e;
  }
  buildBounce(e) {
    var t;
    return t = document.createElement("div"), t.className = "bounce" + e, t;
  }
}
const m = {
  widget(l, e = {}) {
    const t = new h(l, e);
    return t.build(), t.inject(), t;
  }
}, c = ["data-url"], y = {
  __name: "Vue3Calendly",
  props: {
    url: {
      type: String,
      required: !0
    },
    height: {
      type: Number,
      default: 600
    }
  },
  emits: ["load", "calendlyEvent"],
  setup(l, { emit: e }) {
    const t = l, i = e, n = s(null);
    return a(() => {
      m.widget(n.value, {
        onLoad(r) {
          i("load", r);
        }
      }), window.addEventListener("message", function(r) {
        r.origin === "https://calendly.com" && r.data.event && r.data.event.indexOf("calendly.") === 0 && i("calendlyEvent", r.data);
      });
    }), (r, p) => (o(), d("div", {
      ref_key: "calendlyDiv",
      ref: n,
      class: "calendly",
      style: u({ height: t.height + "px" }),
      "data-url": t.url
    }, null, 12, c));
  }
};
export {
  y as Vue3Calendly
};
